import type { LevelData } from './LevelData';

export const EMPTY_LEVEL: LevelData = {
  goal: 100,
  reward: 20,
  board: {
    cols: 8,
    rows: 7,
    hiddenStacks: [],
    stacks: [],
    blockers: [],
  },
  tray: {
    colors: [],
  },
  refills: [
    {
      scoreRange: [0, 0.2],
      availableColors: 4,
      minColors: 1,
      maxColors: 3,
      minFill: 1,
      maxFill: 3,
      freeSpaceMatchChance: [
        {
          freeSpaces: {
            min: 1,
            max: 8,
          },
          matchChance: 1,
          fullMatchChance: 1,
        },
        {
          freeSpaces: {
            min: 9,
            max: 100,
          },
          matchChance: 0,
          fullMatchChance: 0,
        },
      ],
    },
    {
      scoreRange: [0.2, 0.5],
      availableColors: 6,
      minColors: 1,
      maxColors: 3,
      minFill: 1,
      maxFill: 3,
      freeSpaceMatchChance: [
        {
          freeSpaces: {
            min: 1,
            max: 8,
          },
          matchChance: 1,
          fullMatchChance: 1,
        },
        {
          freeSpaces: {
            min: 9,
            max: 100,
          },
          matchChance: 0,
          fullMatchChance: 0,
        },
      ],
    },
    {
      scoreRange: [0.5, 1],
      availableColors: 8,
      minColors: 1,
      maxColors: 3,
      minFill: 1,
      maxFill: 3,
      freeSpaceMatchChance: [
        {
          freeSpaces: {
            min: 1,
            max: 8,
          },
          matchChance: 1,
          fullMatchChance: 0,
        },
        {
          freeSpaces: {
            min: 9,
            max: 100,
          },
          matchChance: 0,
          fullMatchChance: 0,
        },
      ],
    },
  ],
};
